import React from 'react';
import styles from './ButtonGeneral.module.scss';
import { ButtonGeneralProps } from './ButtonGeneral.type';

const ButtonGeneral: React.FC<ButtonGeneralProps> = ({
  title = '0',
  subtitle = 'False Alarm',
  onClick,
  active
}) => {
  return (
    <button
      data-testid="button-general"
      onClick={onClick}
      className={styles['Container'] + ' ' + (active ? styles['active'] : '')}
    >
      <span>{title}</span>
      <small>{subtitle}</small>
    </button>
  );
};

export default ButtonGeneral;
